const Screen = () => (
  <img src="/img/app-screen.webp" alt="Tampilan aplikasi BagiPulsa" className="absolute inset-x-0 bottom-0 top-[22px] h-[calc(100%-22px)] w-full object-cover object-top" loading="lazy" />
);

export const IPhone = ({ className = "" }) => (
  <div data-testid="mockup-ios" className={`relative aspect-[9/19.3] rounded-[2.6rem] bg-gradient-to-b from-zinc-600 via-zinc-800 to-zinc-700 p-[7px] shadow-[0_40px_80px_-20px_rgba(0,0,0,0.7)] ${className}`}>
    <div className="relative h-full w-full overflow-hidden rounded-[2.2rem] bg-[#141414]">
      <Screen />
      <div className="absolute inset-x-0 top-0 flex h-[30px] items-center justify-between px-6 text-[10px] font-semibold text-white">
        <span>08.24</span>
        <span className="h-2.5 w-5 rounded-sm border border-white/80" />
      </div>
      <div className="absolute left-1/2 top-2 h-[18px] w-[34%] -translate-x-1/2 rounded-full bg-black" />
      <div className="absolute bottom-1.5 left-1/2 h-1 w-1/3 -translate-x-1/2 rounded-full bg-white/70" />
    </div>
  </div>
);

export const Android = ({ className = "" }) => (
  <div data-testid="mockup-android" className={`relative aspect-[9/19.5] rounded-[1.9rem] bg-gradient-to-b from-zinc-700 to-zinc-900 p-[5px] shadow-[0_40px_80px_-20px_rgba(0,0,0,0.7)] ${className}`}>
    <div className="absolute -right-[3px] top-[22%] h-12 w-[3px] rounded-r bg-zinc-600" />
    <div className="relative h-full w-full overflow-hidden rounded-[1.6rem] bg-[#141414]">
      <Screen />
      <div className="absolute inset-x-0 top-0 flex h-[24px] items-center justify-between px-4 text-[9px] font-medium text-white">
        <span>08:24</span>
        <span>92%</span>
      </div>
      <div className="absolute left-1/2 top-[7px] h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-black ring-1 ring-zinc-700" />
    </div>
  </div>
);

export const PhonePair = ({ className = "" }) => (
  <div className={`relative flex items-end justify-center ${className}`} data-testid="phone-pair">
    <Android className="w-[44%] max-w-[230px] -rotate-[8deg] translate-x-[8%] translate-y-[4%]" />
    <IPhone className="relative z-10 w-[48%] max-w-[250px] rotate-[6deg] -translate-x-[4%]" />
  </div>
);
